import { 
	createSlice,
	createSelector,
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'

import {
	envAwarePost,
	dateToAPIStandard
} from '../../util/util'

export const getInvoice = createAsyncThunk(
	'financials/getInvoice',
	async token => await envAwarePost(
		'api/financials/',
		{action:'getInvoice',is_public_api_request:1,token}
	)
)

export const markInvoicePaid = createAsyncThunk(
	'financials/markInvoicePaid',
	async payload => await envAwarePost(
		'api/financials/',
		{
			action:'editInvoice',
			is_public_api_request:1,
			update:{paid:1},
			...payload
		}
	)
)

const slice = createSlice({
	name: 'messageCenter',
	initialState : {
		status:'pending',
		invoice:null
	},
	reducers : {
		updateName : (state,action)=>{
			state.invoice.recipient.user_name = action.payload
		}
	},
	extraReducers : {
		[getInvoice.pending] : (state)=>{
			state.status = 'pending'
		},
		[getInvoice.fulfilled] : (state,action)=>{
			state.status = 'idle'
			state.invoice = action.payload.data.invoice
		},
		[markInvoicePaid.pending] : (state)=>{
			state.invoice.paid = 1
		}
	}
})

export const {updateName} = slice.actions

export default slice.reducer